/**
 * Regex to check dutch zipcodes against
 * @type {RegExp}
 */

const zipCodeRegex = /^[1-9][0-9]{3}?(?!sa|sd|ss)[a-z|A-Z]{2}$/i
const zipCodeRegexStreetOptional = /^[1-9][0-9]{3}(?:(?!sa|sd|ss)[a-z|A-Z]{2})?$/i

export default { zipCodeRegex, zipCodeRegexStreetOptional }
